shadow$provide[423] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `varying float vPixelSize;

float getSquareMask(vec2 uv) {
  vec2 a = abs(uv);
  return max(a.x, a.y);
}
`;

};